export enum EnumTipoAdhesionCFlotante {
  SiguienteFactura = 1,
  PeriodoExacto = 2,
  PeriodoParcial = 3,
  AdhesionBloqueada = 4,
  Truncado = 5,
  SaldoLibre = 6,
  SaldoAsignado = 7,
  AccionBalance = 8,
  Derechos = 9,
  Descartado = 10
}
